export const DRAWER_TYPES = {
  addWorklog: 'addWorklog',
  updateWorklog: 'updateWorklog',
  filters: 'filters',
  addNote: 'addNote',
}

export const SCHEDULE_VIEW_TYPES = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
}

export const SCHEDULE_VIEW_TYPES_OPTIONS = {
  [SCHEDULE_VIEW_TYPES.daily]: 'Daily',
  [SCHEDULE_VIEW_TYPES.weekly]: 'Weekly',
  [SCHEDULE_VIEW_TYPES.monthly]: 'Monthly',
}

export const SCHEDULE_TYPES = {
  time: 'time',
  grid: 'grid',
  cl: 'cl',
};

export const SCHEDULE_DAY_VIEWS = {
  time: 'time',
  grid: 'grid',
  cl: 'cl',
};

export const SCHEDULE_DAY_VIEWS_OPTIONS = {
  [SCHEDULE_DAY_VIEWS.time]: 'Time View',
  [SCHEDULE_DAY_VIEWS.grid]: 'Grid View',
  [SCHEDULE_DAY_VIEWS.cl]: 'CL View',
}

export const TIME_VIEW_COLUMN_WIDTH = 203;